// DOGODKI.JS
import React, { useState, useMemo } from "react";
import { Link } from "react-router-dom";
import "./Dogodki.css";
import { useTranslation } from "react-i18next";

import rotarygloballogo from "../Logos/RotaryClubLogo.png";
import AnimatedBackground from "../Layout/AnimatedBackground";

const events = [
  {
    title: "Obisk guvernerja Matjaža Novaka, 24. 11. 2025",
    image: "/Slike/Dogodki/ObiskGuvernerja2025/slika1.webp",
    link: "/Dogodki/Podstrani/ObiskGuvernerja2025/",
  },
  {
    title: "Koncert Žarek Upanja, 06.11.2025 - Vransko",
    image: "/Slike/Dogodki/Koncert2025/slika2.webp",
    link: "/Dogodki/Podstrani/KoncertVransko2025/",
  },
  {
    title: "Predavanje (Svetloba), 31.03.2025 - Žalec",
    image: "/Slike/Dogodki/PredavanjeSvetloba/slika1.webp",
    link: "/Dogodki/Podstrani/PredavanjeSvetloba/",
  },
  {
    title: "Projekt (Podari trenutek), 17.03.2025 - OŠ Mozirje",
    image: "/Slike/Dogodki/PodariTrenutek2025/slika1.webp",
    link: "/Dogodki/Podstrani/PodariTrenutek2025/",
  },
  {
    title: "Degustacija piva pivovarne Vizir, 24.02.2025 - Žalec",
    image: "/Slike/Dogodki/DegustacijaPiva2025/slika1.webp",
    link: "/Dogodki/Podstrani/DegustacijaPiva2025/",
  },
  {
    title: "Potopisno predavanje, 17.02.2025 - Žalec",
    image: "/Slike/Dogodki/PotopisnoPredavanje2025/slika2.webp",
    link: "/Dogodki/Podstrani/PotopisnoPredavanje2025/",
  },
  {
    title: "Dobrodelni koncert (Žarek Upanja), 14.11.2024 - Vransko",
    image: "/Slike/Dogodki/Koncert2024/slika1.webp",
    link: "/Dogodki/Podstrani/KoncertVransko2024/",
  },
  {
    title: "Dražba umetniških slik, 23.09.2024 - Grad Komenda",
    image: "/Slike/Dogodki/Drazba2024/slika1.webp",
    link: "/Dogodki/Podstrani/DrazbaSlik2024/",
  },
];

const EVENTS_PER_PAGE = 8;

const Dogodki = () => {
  const { t } = useTranslation();
  const [currentPage, setCurrentPage] = useState(1);

  const totalPages = Math.ceil(events.length / EVENTS_PER_PAGE);

  const currentEvents = useMemo(() => {
    const startIndex = (currentPage - 1) * EVENTS_PER_PAGE;
    return events.slice(startIndex, startIndex + EVENTS_PER_PAGE);
  }, [currentPage]);

  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handlePageChange = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
    scrollTop();
  };

  return (
    <AnimatedBackground>
      <section className="dogodkikontejnerd">
        <div className="dogodkieventgallery">
          <header className="dogodkiheader">
            <div className="dogodkititle-row">
              <p className="dogodkititle">{t("past_events")}</p>
              <img style={{height:"30px"}}
                src={rotarygloballogo}
                alt="Rotary International Logo"
              />
            </div>
            <p className="dogodkipodnaslov">{t("thank_you_events")}</p>
          </header>

          <div className="dogodkigallerygrid">
            {currentEvents.map((event) => (
              <article className="dogodkigalleryitem" key={event.link}>
                <Link
                  to={event.link}
                  className="dogodkicard"
                  onClick={scrollTop}
                >
                  <div className="dogodkiimagewrapper">
                    <img
                      src={process.env.PUBLIC_URL + event.image}
                      alt={event.title}
                      className="dogodkigalleryimage"
                      loading="lazy"
                    />
                  </div>
                  <div className="dogodkicardbody">
                    <h3 className="dogodkieventtitle">{event.title}</h3>
                  </div>
                </Link>
              </article>
            ))}
          </div>

          {totalPages > 1 && (
            <nav
              className="pagination-controls"
              aria-label={t("pagination") || "Event pagination"}
            >
              <button
                type="button"
                className="pagination-button"
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
              >
                ‹
              </button>

              {Array.from({ length: totalPages }, (_, i) => {
                const page = i + 1;
                return (
                  <button
                    key={page}
                    type="button"
                    className={
                      "pagination-button" +
                      (page === currentPage ? " pagination-button--active" : "")
                    }
                    onClick={() => handlePageChange(page)}
                  >
                    {page}
                  </button>
                );
              })}

              <button
                type="button"
                className="pagination-button"
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
              >
                ›
              </button>
            </nav>
          )}
        </div>
      </section>
    </AnimatedBackground>
  );
};

export default Dogodki;
